import { useContext } from 'react'

import { ABTestContext, type IABTestContext } from './ABTestContext'

const useABTest = (): IABTestContext => {
  return useContext(ABTestContext)
}

export default useABTest
